<template>
  <grouped-bar-chart style="position: relative" :height="height" :data="this.groupedBarChartData"
                     :options="this.groupedBarChartOptions"
                     v-if="this.groupedBarChartData"></grouped-bar-chart>
</template>

<script>
  import moment from "moment";
  import {scrapedProfileSections} from "../../../constants/constants";
  import GroupedBarChart from "../Wrappers/groupedBarChart";

  import {getNumberOfChangesInSection} from "../../../helpers/helpers";

  export default {
    name: "sectionsCompletionBars",
    components: {GroupedBarChart},
    props: ['profile', 'height'],
    data(){
      return {
        groupedBarChartData: {},
        groupedBarChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top"
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: true,
                color: '#eee'
              },
            }],
            yAxes: [{
              id:'A',
              gridLines: {
                display: false
              },
              ticks: {
                suggestedMax: 100
              }
            },
            {
              id:'B',
              gridLines: {
                display: false
              },
              position: 'right',
              ticks: {
                suggestedMin: 0,
                suggestedMax:60,
              }
            }]
          },
        },
      }
    },
    methods: {
      getNumberOfChangesInSection(item) {
        return getNumberOfChangesInSection(item);
      },
      composeGroupedBarChartData() {
        const labels = this.profile.history.map(e => e.scrapedDate).reverse().map(e => moment(e).format('DD-MMM'));
        let datasets = [];

        let profileCompletion = JSON.parse(JSON.stringify(this.profile.edges.market.profileCompletion));
        delete profileCompletion.total;
        delete profileCompletion.scrapedDate;
        const sections = Object.keys(profileCompletion);

        let profileCompletionHistory = JSON.parse(JSON.stringify(this.profile.edges.market.profileCompletionHistory)).reverse();

        for (let i = 0; i < sections.length; i++) {
          let section = sections[i];
          let bar = {
            label: section,
            backgroundColor: scrapedProfileSections.filter(e => e.section === section)[0].colorFill,
            borderColor: scrapedProfileSections.filter(e => e.section === section)[0].colorLine,
            borderWidth: 1,
            data: profileCompletionHistory.map(e => e[section])
          };
          datasets.push(bar);
        }

        datasets.push({
          label: 'total',
          data: profileCompletionHistory.map(e => Math.round(e.total / sections.length)),
          type: 'line',
          fill: false,
          yAxisID: 'B',
        });

        return {labels, datasets};
      },
    },
    mounted(){
      this.groupedBarChartData = this.composeGroupedBarChartData();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Profile/sectionsCompletionBars.vue